import { render, staticRenderFns } from "./InventoryPrintComponent.vue?vue&type=template&id=a87496c2"
import script from "./InventoryPrintComponent.vue?vue&type=script&lang=js"
export * from "./InventoryPrintComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports